import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from '@/components/ui/toast'
import { useNotificationStore } from '@/store/notification-store'

const AUTO_DISMISS_MS = 7000

/** Renders transient import-result notifications (success/error per file). */
export function Toaster() {
  const notifications = useNotificationStore((s) => s.notifications)
  const dismiss = useNotificationStore((s) => s.dismiss)

  return (
    <ToastProvider swipeDirection="right">
      {notifications.map((notification) => (
        <Toast
          key={notification.id}
          variant={notification.variant}
          duration={AUTO_DISMISS_MS}
          onOpenChange={(open) => {
            if (!open) dismiss(notification.id)
          }}
        >
          <div className="grid gap-1">
            <ToastTitle>{notification.title}</ToastTitle>
            {notification.description != null && (
              <ToastDescription>{notification.description}</ToastDescription>
            )}
          </div>
          <ToastClose aria-label="Dismiss notification" />
        </Toast>
      ))}
      <ToastViewport />
    </ToastProvider>
  )
}
